import React from "react";
import Card from "components/ui/Card/Card";
import Icon from "components/ui/Icon/Icon";
import styles from "./SettingsGrid.module.scss";

type SettingsTile = {
  icon: string;
  label: string;
  description?: string;
  onClick?: () => void;
};

const settingsTiles: SettingsTile[] = [
  {
    icon: "zone",
    label: "Zone",
  },
  {
    icon: "vendor",
    label: "Vendor",
  },
  {
    icon: "pump",
    label: "Pump",
  },
  {
    icon: "atm",
    label: "ATM",
  },
  {
    icon: "cost",
    label: "Cost",
  },
  {
    icon: "userManage",
    label: "User",
  },
];

function SettingsGrid() {
  return (
    <section className={styles.section}>
      <header className={styles.header}>Settings</header>
      <div className={styles.grid}>
        {settingsTiles.map((tile) => (
          <Card key={tile.label} className={styles.tile}>
            <div className={styles.iconWrap}>
              <Icon name={tile.icon} fontSize="large" />
            </div>
            <div className={styles.label}>{tile.label}</div>
          </Card>
        ))}
      </div>
    </section>
  );
}

export default SettingsGrid;
